module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised btn",
    attrs: {
      "label": "Print",
      "icon": "pi pi-print"
    },
    on: {
      "click": _vm.generateReport
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger btn",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.back()
      }
    }
  })], 1)]), _vm._v(" "), (_vm.printType === 'bill' || _vm.printType === 'qot') ? _c('Card', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-4"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-4"
        }, [_c('img', {
          staticClass: "img-responsive center-block logo",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "src": _vm.$store.state.organisationLogo,
            "alt": "Logo"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-col-4"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-1"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-10"
        }, [_c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "font-size": "18px"
          }
        }, [_vm._v(_vm._s(_vm.organisationName))]), _vm._v(" "), _c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "margin-top": "-8px"
          }
        }, [_vm._v(_vm._s(_vm.organisationAddress))]), _vm._v(" "), _c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "margin-top": "-8px"
          }
        }, [_vm._v(_vm._s(_vm.organisationContact))]), _vm._v(" "), _c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "margin-top": "-8px"
          }
        }, [_vm._v("Pan No: " + _vm._s(_vm.organisationPanNo))]), _vm._v(" "), _c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "margin-top": "-8px"
          }
        }, [_vm._v("Cash Receipt")])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-1"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-6"
        }, [_c('span', [_vm._v("Name:" + _vm._s(_vm.customerName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Contact:" + _vm._s(_vm.customerNumber))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-6",
          staticStyle: {
            "margin-left": "-4%"
          }
        }, [_c('span', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Date: " + _vm._s(_vm.nepaliDate))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Bill No: " + _vm._s(_vm.billNo))])])]), _vm._v(" "), _c('table', {
          staticClass: "table table-bordered",
          staticStyle: {
            "max-width": "96%"
          }
        }, [_c('thead', {
          staticStyle: {
            "padding": "4px",
            "font-size": "10px"
          }
        }, [_c('tr', [_c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("S.n")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Particular")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Rate")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Amount")])])]), _vm._v(" "), _vm._l((_vm.salesList), function(item, index) {
          return _c('tbody', {
            key: index
          }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "right"
            }
          }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "right"
            }
          }, [_vm._v(_vm._s(item.sellingPrice) + " ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "right"
            }
          }, [_vm._v(_vm._s(item.sellingPrice * item.quantity) + " ")])])])
        }), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "colspan": "1"
          }
        }, [_vm._v("Total:")]), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-align": "right"
          }
        }, [_vm._v(_vm._s(_vm.totalQty))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-align": "right"
          }
        }, [_vm._v(_vm._s(_vm.totalSubTotal))])])])], 2), _vm._v(" "), _c('div', {
          staticClass: "p-grid p-col-12"
        }, [_c('div', {
          staticClass: "p-col-12"
        }, [_c('span', {
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Gross Amount: " + _vm._s(_vm.subTotalAmount))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-12"
        }, [_c('span', {
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Discount Amount: " + _vm._s(_vm.discountAmt))])]), _vm._v(" "), (this.taxType === 'Vat') ? _c('div', {
          staticClass: "p-col-12"
        }, [_c('span', {
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Vatable Amount: " + _vm._s(_vm.vatAmount))])]) : _vm._e(), _vm._v(" "), (this.taxType === 'Vat') ? _c('div', {
          staticClass: "p-col-12"
        }, [_c('span', {
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Vat 13%: " + _vm._s(_vm.vatPercentage))])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "p-col-12"
        }, [_c('span', {
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Total Amount: " + _vm._s(_vm.billAmount))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-12"
        }, [_c('span', {
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Tender Amount: " + _vm._s(_vm.tenderAmount))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-12"
        }, [_c('span', [_vm._v("Amount In Words: " + _vm._s(_vm.amountInWords))])])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-12"
        }, [_c('span', {
          staticStyle: {
            "float": "right",
            "margin-right": "38px"
          }
        }, [_vm._v("Received By: " + _vm._s(_vm.receivedBy))])]), _vm._v(" "), _c('div', {
          staticClass: "p-grid p-col-12"
        }, [_c('div', {
          staticClass: "p-col-12 p-offset-3"
        }, [_c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("Powered By Raise Tech Pvt.Ltd.")])])])]
      },
      proxy: true
    }], null, false, 2223252277)
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.printType === 'qot') ? _c('Card', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-4"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-4"
        }, [_c('img', {
          staticClass: "img-responsive center-block logo",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "src": _vm.$store.state.organisationLogo,
            "alt": "Logo"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-col-4"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-1"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-10"
        }, [_c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "font-size": "18px"
          }
        }, [_vm._v(_vm._s(_vm.organisationName))]), _vm._v(" "), _c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "margin-top": "-8px"
          }
        }, [_vm._v(_vm._s(_vm.organisationAddress))]), _vm._v(" "), _c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "margin-top": "-8px"
          }
        }, [_vm._v(_vm._s(_vm.organisationContact))]), _vm._v(" "), _c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "margin-top": "-8px"
          }
        }, [_vm._v("KOT")])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-1"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-6"
        }, [_c('span', [_vm._v("Name:" + _vm._s(_vm.customerName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Contact:" + _vm._s(_vm.customerNumber))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-6",
          staticStyle: {
            "margin-left": "-4%"
          }
        }, [_c('span', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Date: " + _vm._s(_vm.nepaliDate))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Bill No: " + _vm._s(_vm.billNo))])])]), _vm._v(" "), _c('table', {
          staticClass: "table table-bordered"
        }, [_c('thead', {
          staticStyle: {
            "padding": "4px",
            "font-size": "10px"
          }
        }, [_c('tr', [_c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("S.n")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Particular")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Qty")])])]), _vm._v(" "), _vm._l((_vm.salesList), function(item, index) {
          return _c('tbody', {
            key: index
          }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "right"
            }
          }, [_vm._v(_vm._s(item.quantity))])])])
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "p-col-12"
        }, [_c('span', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("Received By: " + _vm._s(_vm.receivedBy))])])]
      },
      proxy: true
    }], null, false, 2385164731)
  }) : _vm._e(), _vm._v(" "), (_vm.printType === 'qott') ? _c('Card', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-4"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-4"
        }, [_c('img', {
          staticClass: "img-responsive center-block logo",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "src": _vm.$store.state.organisationLogo,
            "alt": "Logo"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-col-4"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-1"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-col-10"
        }, [_c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "font-size": "18px"
          }
        }, [_vm._v(_vm._s(_vm.organisationName))]), _vm._v(" "), _c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "margin-top": "-8px"
          }
        }, [_vm._v(_vm._s(_vm.organisationAddress))]), _vm._v(" "), _c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "margin-top": "-8px"
          }
        }, [_vm._v(_vm._s(_vm.organisationContact))]), _vm._v(" "), _c('h5', {
          staticStyle: {
            "text-align": "-webkit-center",
            "margin-top": "-8px"
          }
        }, [_vm._v("KOT")])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-1"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-grid"
        }, [_c('div', {
          staticClass: "p-col-6"
        }, [_c('span', [_vm._v("Name:" + _vm._s(_vm.customerName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Contact:" + _vm._s(_vm.customerNumber))])]), _vm._v(" "), _c('div', {
          staticClass: "p-col-6",
          staticStyle: {
            "margin-left": "-4%"
          }
        }, [_c('span', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Date: " + _vm._s(_vm.nepaliDate))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "for": "fromDate"
          }
        }, [_vm._v("Bill No: " + _vm._s(_vm.billNo))])])]), _vm._v(" "), _c('table', {
          staticClass: "table table-bordered"
        }, [_c('thead', {
          staticStyle: {
            "padding": "4px",
            "font-size": "10px"
          }
        }, [_c('tr', [_c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("S.n")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Particular")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("Qty")])])]), _vm._v(" "), _vm._l((_vm.salesList), function(item, index) {
          return _c('tbody', {
            key: index
          }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "text-align": "right"
            }
          }, [_vm._v(_vm._s(item.quantity))])])])
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "p-col-12"
        }, [_c('span', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("Received By: " + _vm._s(_vm.receivedBy))])])]
      },
      proxy: true
    }], null, false, 2385164731)
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-506c3733"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pos/posPrintPage.vue
// module id = 2226
// module chunks = 0